import { render, staticRenderFns } from "./ship_quit_detail.vue?vue&type=template&id=aa377710&"
import script from "./ship_quit_detail.vue?vue&type=script&lang=js&"
export * from "./ship_quit_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports